import React, { useEffect, useState } from 'react';
import style from './Dashboard.module.scss';
import { Breadcrumb, Container, PageTitle } from '@skf/bt-wind-rail-commonlibrary';
import { useTranslation } from 'react-i18next';
import { IRoute, Routes } from '../../../routes/routes';
import { usePathname } from '../../../hooks/usePathname';
import { matchPath } from 'react-router';

interface IDashboardLayoutProps {}

export const DashboardLayout: React.FunctionComponent<IDashboardLayoutProps> = (
  {
    children
  }
) => {
  const { t } = useTranslation();
  const { setPathname, pathname } = usePathname();

  const [currentRoute, setCurrentRoute] = useState<IRoute>();
  const [title, setTitle] = useState<string>('');

  const [homePageTitle, setHomePageTitle] = useState<string | undefined>();
  const [currentPageTitle, setCurrentPageTitle] = useState<string | undefined>();
  const [currentSectionTitle, setCurrentSectionTitle] = useState<string | undefined>();

  useEffect(() => {
    setCurrentRoute(getRouteFromPath(pathname));
  }, [pathname]);

  const getHomePagePath = () => currentRoute?.path.split('/')[1];
  const getCurrentPagePath = () => currentRoute?.path.split('/').splice(0, 3).join('/');
  const getRouteFromPath = (_pathname: string) => Routes.find(route => {
    const response = matchPath(_pathname, {
      path: route.path,
      exact: true
    });
    return response?.isExact;
  });

  useEffect(() => {
    if(!currentRoute) return;
    const [, _homePagePath, _currentPagePath, _currentSectionPath] = currentRoute.path.split('/');

    setTitle(getRouteFromPath(pathname)?.title || '');

    setHomePageTitle(getRouteFromPath(`/${_homePagePath}`)?.title);
    setCurrentPageTitle(getRouteFromPath(`/${_homePagePath}/${_currentPagePath}`)?.title);
    setCurrentSectionTitle(getRouteFromPath(`/${_homePagePath}/${_currentPagePath}/${_currentSectionPath}`)?.title);
  }, [currentRoute]);

  const onClickHomePage = () => {
    const targetPath = getHomePagePath();
    if(!targetPath) return;
    setPathname(`/${targetPath}`);
  };
  const onClickCurrentPageTitle = () => {
    const targetPath = getCurrentPagePath();
    if(!targetPath) return;
    setPathname(targetPath);
  };

  return (
    <main className={style.dashboard}>
      {
        homePageTitle && (
            <>
              <Breadcrumb
                homePageTitle={t(homePageTitle)}
                currentPageTitle={currentPageTitle && t(currentPageTitle)}
                currentSectionTitle={currentSectionTitle && t(currentSectionTitle)}
                onClickHomePage={onClickHomePage}
                onClickCurrentPageTitle={onClickCurrentPageTitle}
              />
              <PageTitle title={t(title)} />
            </>
        )
      }
      <Container className={style.container}>
        {children}
      </Container>
    </main>
  );
};
